import { useState } from 'react';
import { Modal } from 'antd';
import { Button } from '@cropler/ui-kit';
import { Organization } from './Organization';

import { ReactComponent as Logo } from '../../assets/images/logoSidebar.svg';

import styles from './styles.module.css';
import { useViewport } from '../../hooks';
import { BreakpointMobile, BreakpointMobileUp } from '../../constants/ui';
import { useDispatch, useSelector } from 'react-redux';
import { statusWelcomeModal, statusWorkspaceModal } from '../../store/slices/ui';
import { AddWorkspaceModal } from '../../constants/keys';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

export const WorkspaceModal = ({ t, isOnlyDemoWorkspace, setWorkspaceId, showOnlyCreateForm, setActiveModal }) => {
  const dispatch = useDispatch();
  const [organization, createOrganization] = useState(false);
  const { widthViewport } = useViewport();
  const { welcomeModalStatus } = useSelector((state) => state.ui);

  const closeModal = () => {
    dispatch(statusWelcomeModal(false));
    dispatch(statusWorkspaceModal(false));
    // if is_demo show modal only once
    if (isOnlyDemoWorkspace) {
      localStorage.setItem(AddWorkspaceModal, JSON.stringify('close'));
    }
  }

  return (
    <Modal
      title={false}
      transitionName=""
      centered
      open={welcomeModalStatus}
      closeIcon={false}
      footer={false}
      width={501}
      className="workspace-modal modalNoPadding"
      rootClassName={'workspace-modal-root'}
    >
      <div className={styles.workspaceModalContainer}>
        <Button size={'small'} type="gray" className={styles.workspaceModalClose} onClick={() => closeModal()} icon={<CroplerIcon name="close" />} />
        {!organization && !showOnlyCreateForm && (
          <>
            <div className={styles.workspaceModalImageContainer}>
              {widthViewport > BreakpointMobile && (
                <>
                  <Logo />
                  <span>{t('workspaceModal.title')}</span>
                </>
              )}
            </div>
            <div className={styles.workspaceModalInfoContainer}>
              <div className={styles.workspaceModalInfoBody}>
                {widthViewport < BreakpointMobileUp && (
                  <h2 className={styles.workspaceModalTitle}>{t('workspaceModal.title')}</h2>
                )}
                <p dangerouslySetInnerHTML={{ __html: t('workspaceModal.text1') }}></p>
                <p dangerouslySetInnerHTML={{ __html: t('workspaceModal.text2') }}></p>
              </div>
              <div className={styles.workspaceModalAccounts}>
                <Button type="primary" onClick={() => createOrganization(true)}>
                  {t('actions.next')}
                </Button>
              </div>
            </div>
          </>
        )}
        {(organization || showOnlyCreateForm) && (
          <>
            {widthViewport < BreakpointMobileUp && <div className={styles.workspaceModalImageContainer}></div>}
            <Organization
              goBack={() => createOrganization(false)}
              setWorkspaceId={setWorkspaceId}
              setActiveModal={setActiveModal}
              showOnlyCreateForm={showOnlyCreateForm}
              t={t}
            />
          </>
        )}
      </div>
    </Modal>
  );
};
